import React, { useState, useCallback, useMemo } from "react";
import { IoMdArrowBack } from "react-icons/io";
import OutlinedButton from "components/layout/form/outlinedButton";
import { HeaderContainer } from "../styles";
import { Method } from "axios";
import {
  Container,
  ContainerButtons,
  FormContainer,
  TextContact,
  RadioContent,
  Error,
  OpenModalQuestionsWrap,
} from "./styles";
import { arrUniqueContactMFA, sendToken } from "../utils";
import { Formik } from "formik";
import RadioField from "components/layout/form/radioField";
import * as Yup from "yup";
import { MdLocalPhone } from "react-icons/md";
import { FiMail } from "react-icons/fi";
import QuestionPool from "./QuestionPool";
import ValidationContact from "./ValidationContact";

const TypeToken = ({ setStep, userInfo, setUserInfo, setContactId }) => {
  const [loading, setLoading] = useState();
  const [openModalQuestions, setOpenModalQuestions] = useState(false);
  const [openModalNewContact, setOpenModalNewContact] = useState(false);
  const [tokenQuestions, setTokenQuetions] = useState("");

  const { document, userId } = userInfo;
  const handleSubmit = useCallback(
    async (contactId) => {
      if (!loading) {
        setLoading(true);
        const contact = userInfo?.contacts?.find(
          (item) => contactId === item?.contactId
        );
        const success = await sendToken(contact, userInfo?.userId);
        if (success) {
          setStep(3);
          setUserInfo({ ...userInfo, validationContactId: contact?.contactId });
        }
        setLoading(false);
      }
    },
    [sendToken, loading]
  );

  const validatorSchema = () =>
    Yup.object().shape({
      type: Yup.string().required("É necessário selecionar um tipo de token"),
    });

  const handleModal = (show, enableEditing) => {
    setOpenModalQuestions(show);

    if (enableEditing) {
      setOpenModalNewContact(true);
    }
  };

  const handleCloseModalNewContact = () => {
    setOpenModalNewContact(false);
  };

  const finishNewContact = () => {
    setStep(4);
  };

  const contactsResponse = useMemo(() => {
    if (userInfo?.contacts?.length === 0) return [];

    let contactsResponse = [];

    contactsResponse = userInfo?.contacts?.filter(
      (contact) => contact.isContactValidated === true
    );

    contactsResponse =
      contactsResponse.length > 0 ? contactsResponse : userInfo?.contacts;

    contactsResponse = contactsResponse?.sort((a, b) => {
      if (a.contactType === b.contactType) {
        return (a.contact || "").localeCompare(b.contact || "");
      }

      if (a.contactType === "PHONE") return -1;
      if (b.contactType === "PHONE") return 1;
      return 0;
    });

    contactsResponse = arrUniqueContactMFA(contactsResponse);

    return contactsResponse;
  }, [userInfo]);

  const hasContacts = useMemo(() => {
    return contactsResponse?.length > 0;
  }, [contactsResponse]);

  return (
    <>
      <Container>
        <HeaderContainer>
          <h1>Esqueci minha senha</h1>
          {hasContacts && <h2>Informe de que forma deseja receber o código</h2>}
        </HeaderContainer>

        <Formik
          initialValues={{
            type: "",
          }}
          validationSchema={validatorSchema}
          onSubmit={() => {}}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <FormContainer>
              {contactsResponse?.map((contact) => (
                <RadioContent
                  key={contact.contactId}
                  active={values.type === contact?.contactId}
                  onClick={() => {
                    setFieldValue("type", contact?.contactId);
                    handleSubmit(contact?.contactId);
                  }}
                >
                  <RadioField
                    id={contact?.contactId}
                    type="radio"
                    name="type"
                    value={contact?.contactId}
                    checked={values.type === contact?.contactId}
                    readOnly
                  >
                    <div>
                      {contact?.contactType === "PHONE" ? (
                        <MdLocalPhone />
                      ) : (
                        <FiMail />
                      )}
                      <span>
                        Via {contact?.contactType === "PHONE" ? "SMS" : "email"}
                      </span>
                    </div>
                    <span>{contact?.contact}</span>
                  </RadioField>
                </RadioContent>
              ))}
              {errors.type && touched.type && errors.type && (
                <Error>{errors.type}</Error>
              )}
              <OpenModalQuestionsWrap
                onClick={() => setOpenModalQuestions(true)}
              >
                {hasContacts ? (
                  <>
                    Não reconheço nenhum desses contatos. Quero alterar os dados
                    cadastrados.
                  </>
                ) : (
                  <>Nenhum contato válido encontrado. Desejo cadastrar um novo contato.</>
                )}
              </OpenModalQuestionsWrap>
              <ContainerButtons>
                <OutlinedButton
                  width="100%"
                  LeadingIcon={() => <IoMdArrowBack size={20} />}
                  onClick={() => setStep(1)}
                >
                  Voltar
                </OutlinedButton>
              </ContainerButtons>
            </FormContainer>
          )}
        </Formik>
        {openModalQuestions && (
          <QuestionPool
            body={{ document, userId }}
            handleModal={handleModal}
            setLoading={setLoading}
            setTokenQuetions={setTokenQuetions}
          />
        )}
        <ValidationContact
          setContactId={setContactId}
          document={document}
          userId={userId}
          show={openModalNewContact}
          handleCloseModal={handleCloseModalNewContact}
          finishNewContact={finishNewContact}
          tokenQuestions={tokenQuestions}
          setStepSideBar={setStep}
        />
      </Container>
    </>
  );
};

export default TypeToken;
